export const DIALOG_PAPER_CLASSES = 'rounded-16 shadow-04 p-0 m-0 flex overflow-hidden';
